import { ManufacturingLifecycleStatus } from '../../constants/manufacturing-lifecycle-status.js';
import { MANUFACTURING_TERMINAL_STATUS_IDS } from './terminal-status-ids.js';
/**
 * The statuses whose schedule and note can still be edited — everything but the two terminal ones.
 *
 * Wider than `MANUFACTURING_ORDER_EDITABLE_STATUS_IDS`, and deliberately so. That list is Draft
 * only because a warehouse or a line decides which recipe each line resolves to, and release has
 * already baked that into work orders. When a job is *planned for* changes nothing about what it
 * builds — a job slipping a week is the most ordinary thing a planner does, and refusing it forced
 * them to cancel and re-raise the whole job. A finished or cancelled job is history, so it stops.
 */
export const MANUFACTURING_ORDER_SCHEDULE_EDITABLE_STATUS_IDS = Object.values(ManufacturingLifecycleStatus)
    .filter((value) => typeof value === 'number')
    .filter((status) => !MANUFACTURING_TERMINAL_STATUS_IDS.includes(status));
//# sourceMappingURL=schedule-editable-status-ids.js.map